import './CallToAction.scss';

import { createClsNameMap, mapModifiers } from '@utils';

import type { CTAButtonProps } from '@/features/filter-product-list/product-list/product-item/CallToActionButton';
import CTAButton from '@/features/filter-product-list/product-list/product-item/CallToActionButton';

export const clsNameMap = createClsNameMap({
  modifiers: ['column', 'full-width', 'hide'],
})('cta-buttons');

export type CallToActionProps = {
  showButtonOnHover?: boolean;
  layout?: 'vertical' | 'horizontal';
  buttons: Array<CTAButtonProps>;
  buttonPropsApplyAll?: CTAButtonProps;
};

const CallToAction = ({
  layout,
  buttons,
  showButtonOnHover,
  buttonPropsApplyAll,
}: CallToActionProps) => {
  return (
    <div
      className={mapModifiers(clsNameMap, {
        hide: showButtonOnHover,
        column: layout === 'vertical',
      })}
    >
      {buttons.map((item, index) => (
        <CTAButton key={index} {...item} {...buttonPropsApplyAll} />
      ))}
    </div>
  );
};

export default CallToAction;
